/**
 * color-swatches.js
 * カラーフィルターのスウォッチ（色付き丸）を動的に適用する
 *
 * 新色追加: colorMap に { '色名': '#HEXコード' } を1行追加するだけ。
 * 辞書にない色は部分一致で近似値を探し、それもなければ #cccccc にフォールバック。
 */

window.ColorSwatches = (function () {
  /* =============================================
     色名 → HEXコード 辞書
     ※ 長いキーほど優先的に部分一致するため、
       ブルーグレーはブルー/グレーより前に書くと精度が上がる
  ============================================= */
  var colorMap = {
    /* --- グレー系 --- */
    'チャコールグレー':  '#4A4A4A',
    'チャコール':        '#4A4A4A',
    'グレー':            '#888888',
    /* --- ブラック / ホワイト --- */
    'ブラック':          '#1A1A1A',
    'ホワイト':          '#F5F5F5',
    'オフホワイト':      '#F0EDE8',
    'クリーム':          '#FFFDD0',
    /* --- ネイビー / ブルー系 --- */
    'コバルトブルー':    '#0047AB',
    'ロイヤルブルー':    '#4169E1',
    'スカイブルー':      '#87CEEB',
    'ライトブルー':      '#ADD8E6',
    'ブルーグレー':      '#6D8096',
    'ネイビー':          '#1B2A4A',
    'ブルー':            '#3A6CC8',
    /* --- レッド系 --- */
    'バーガンディ':      '#800020',
    'ワイン':            '#722F37',
    'レッド':            '#CC2222',
    /* --- ピンク / オレンジ系 --- */
    'ホットピンク':      '#FF69B4',
    'サーモンピンク':    '#FA8072',
    'サーモン':          '#FA8072',
    'ライトピンク':      '#FFB6C1',
    'ピンク':            '#F4A0B0',
    'テラコッタ':        '#CC6644',
    'オレンジ':          '#FF8C00',
    /* --- イエロー / ゴールド系 --- */
    'マスタード':        '#C8960C',
    'イエロー':          '#F0C830',
    'ゴールド':          '#D4A020',
    /* --- グリーン系 --- */
    'ライトグリーン':    '#90EE90',
    'オリーブグリーン':  '#556B2F',
    'フォレストグリーン':'#228B22',
    'ミントグリーン':    '#98E8C8',
    'カーキグリーン':    '#6B6B2A',
    'オリーブ':          '#6B6B2A',
    'カーキ':            '#7A7A3A',
    'ミント':            '#98E8C8',
    'グリーン':          '#3A8A3A',
    'ライム':            '#A0C830',
    /* --- ブラウン / ベージュ系 --- */
    'ダークブラウン':    '#4E2A04',
    'キャメル':          '#C19A6B',
    'タン':              '#D2B48C',
    'サンド':            '#D4B896',
    'ブラウン':          '#7A4020',
    'ベージュ':          '#E8D5B0',
    /* --- シルバー / ブロンズ --- */
    'シルバー':          '#B0B0B0',
    'ブロンズ':          '#CD7F32',
    /* --- パープル系 --- */
    'バイオレット':      '#8B00FF',
    'ライラック':        '#C8A2C8',
    'ラベンダー':        '#C8A8D8',
    'パープル':          '#7B3F9E',
    /* --- その他 --- */
    'その他':            '#efefef',

    /* --- English labels (/en/ ロケール用) ― 全大文字で出力される --- */
    'YELLOW':            '#F0C830',
    'ORANGE':            '#FF8C00',
    'GREEN':             '#3A8A3A',
    'GRAY':              '#888888',
    'GOLD':              '#D4A020',
    'SILVER':            '#B0B0B0',
    'NAVY':              '#1B2A4A',
    'PINK':              '#F4A0B0',
    'BROWN':             '#7A4020',
    'BLACK':             '#1A1A1A',
    'BLUE':              '#3A6CC8',
    'BEIGE':             '#E8D5B0',
    'WHITE':             '#F5F5F5',
    'LAVENDER':          '#C8A8D8',
    'RED':               '#CC2222',
    'OTHERS':            '#efefef',
    'PATTERNED':         '#efefef',
  };

  /**
   * 色名からHEXを返す。
   * 1. 完全一致
   * 2. 部分一致（長いキー優先 = より具体的な色名が勝つ）
   * 3. フォールバック: #cccccc
   */
  function getColor(name) {
    if (!name) return '#cccccc';
    if (colorMap[name]) return colorMap[name];

    var keys = Object.keys(colorMap).sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < keys.length; i++) {
      if (name.indexOf(keys[i]) !== -1) return colorMap[keys[i]];
    }
    return '#cccccc';
  }

  function apply() {
    var swatches = document.querySelectorAll('.color-swatch[data-color-name]');
    swatches.forEach(function (el) {
      var name = el.dataset.colorName;
      /* 柄はCSSのストライプグラデーション */
      if (name === '柄' || name.indexOf('柄') !== -1 || name === 'PATTERNED') {
        el.style.background =
          'repeating-linear-gradient(45deg, #ccc 0px, #ccc 3px, #fff 3px, #fff 6px)';
        return;
      }
      el.style.background = getColor(name);
    });
  }

  /**
   * Shopify がフィルター選択後に AJAX でフィルター HTML を差し替えるため、
   * MutationObserver で nav.slide_filters の変化を監視し、
   * 新しい .color-swatch が追加されたら自動で再適用する。
   */
  function observeMutations() {
    var container = document.querySelector('nav.slide_filters');
    if (!container) return;

    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(apply, 50);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    apply();
    observeMutations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { apply: apply, getColor: getColor };
})();
